<template>
  <select
    :value="currentLocale"
    :aria-label="$t('client_page.language')"
    class="locale-select"
    data-testid="locale-select"
    @change="changeLocale"
  >
    <option v-for="locale in locales" :key="locale.value" :value="locale.value">
      {{ locale.text }}
    </option>
  </select>
</template>

<script>
// Лёгкий общий селектор без импортов: ClientResult и ClientLogin входят в
// изолированный набор возврата, который должен пережить откат кабинета.
export default {
  name: "LocaleSelect",
  data() {
    return {
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
    };
  },
  computed: {
    currentLocale() {
      if (this.$i18n && this.$i18n.locale) return this.$i18n.locale;
      if (this.$root && this.$root.$i18n) return this.$root.$i18n.locale;
      return "en";
    },
  },
  methods: {
    changeLocale(event) {
      const locale = event.target.value;
      if (this.$i18n) this.$i18n.locale = locale;
      if (this.$root && this.$root.$i18n) this.$root.$i18n.locale = locale;
      localStorage.setItem("lang", locale);
    },
  },
};
</script>

<style scoped>
.locale-select {
  min-height: 32px;
  max-width: 168px;
  padding: 4px 8px;
  border: 1px solid currentColor;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 13px;
  opacity: 0.72;
}

.locale-select:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
  opacity: 1;
}

.locale-select option {
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
}
</style>
